var exitIntentPopupInstance;

$(document).ready(function () {
    if (siteMetaData.exitIntentContentItemIds.length > 0) {
        new bootstrap.Modal(document.getElementById('exitIntentPopup'));
        var exitIntentDetailsPromise = getExitIntentDetails(siteMetaData.exitIntentContentItemIds);

        exitIntentDetailsPromise.then(
            function (exitIntentList) {
                if (exitIntentList) {
                    exitIntentPopupInstance = new ExitIntentPopup("#exitIntentPopup");
                    exitIntentPopupInstance.displayPopup(exitIntentList);
                }
            },
            function (error) {
                console.error(error);
            }
        );
    }
});

function getExitIntentDetails(contentItemIds) {
    return new Promise((resolve, reject) => {
        let queryString = contentItemIds.map(item => `contentItemIds=${encodeURIComponent(item)}`).join('&');
        $.ajax({
            url: AppConfig_AppPaths_WebURL.value + '/exit-intent?' + queryString,
            type: "GET",
            success: function (data) {
                resolve(data);
            },
            error: function (error) {
                reject(error);
            }
        });
    });
}